import React from 'react'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'
import Logo from '../../assets/images/The Etho Word Logo.png'

class MobileMegaMenu extends React.Component {
	toggleNavs = e => {
		let navListsArr = document.querySelectorAll('.list-items')
		let categoryToShow = e.currentTarget.dataset.navtoggle

		navListsArr.forEach((navList, i) => {
			navList.classList.remove('active')

			if (navList.id === categoryToShow) {
				navList.classList.add('active')
			}
		})
	}

	closeNav = () => {
		document
			.querySelector('#mmega-menu__container')
			.classList.remove('show')
	}

	render() {
		return (
			<nav id='mmega-menu__container'>
				<div className='navigation__window'>
					<FAI icon='times' size='lg' onClick={this.closeNav} />
					<div id='categories' className='list-items active'>
						<a href='/' className='list-item__link'>
							<img src={Logo} alt='The Etho Logo' />
						</a>

						<div
							className='list-item__link'
							onClick={this.toggleNavs}
							data-navtoggle='women'>
							Womens
							<FAI icon='chevron-right' size='lg' />
						</div>

						<div
							className='list-item__link'
							onClick={this.toggleNavs}
							data-navtoggle='men'>
							Mens
							<FAI icon='chevron-right' size='lg' />
						</div>

						<a className='list-item__link' href='/kids/'>
							Kids
						</a>

						<div
							className='list-item__link'
							onClick={this.toggleNavs}
							data-navtoggle='beauty'>
							Beauty
							<FAI icon='chevron-right' size='lg' />
						</div>

						<div
							className='list-item__link'
							onClick={this.toggleNavs}
							data-navtoggle='shoes'>
							Shoes
							<FAI icon='chevron-right' size='lg' />
						</div>

						<div
							className='list-item__link'
							onClick={this.toggleNavs}
							data-navtoggle='lifestyle'>
							Lifestyle
							<FAI icon='chevron-right' size='lg' />
						</div>

						<div
							className='list-item__link'
							onClick={this.toggleNavs}
							data-navtoggle='home-goods'>
							Home
							<FAI icon='chevron-right' size='lg' />
						</div>

						<a className='list-item__link' href='/wholesale'>
							Wholesale
						</a>

						<div
							className='list-item__link'
							onClick={this.toggleNavs}
							data-navtoggle='about-us'>
							About Us
							<FAI icon='chevron-right' size='lg' />
						</div>

						<a href='/login' className='list-item__link'>
							Login/Sign Up
						</a>
					</div>

					{/* SECOND TIER CATEGORIES */}

					<div id='women' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a href='/women/tops' className='list-item__link'>
							Tops
						</a>
						<a href='/women/' className='list-item__link'>
							Bottoms
						</a>
						<a href='/women/dresses' className='list-item__link'>
							Dresses
						</a>
						<a
							href='/women/womens-yoga'
							className='list-item__link'>
							Women's Yoga
						</a>
						<a
							href='/women/bathing-suits'
							className='list-item__link'>
							Bathing Suits
						</a>
						<a href='/women/outer-wear' className='list-item__link'>
							Outer Wear
						</a>
						<a
							href='/women/lingerie-and-loungewear'
							className='list-item__link'>
							Lingerie + Loungewear
						</a>
						<a href='/women/' className='list-item__link'>
							All Women's
						</a>
					</div>

					<div id='men' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a href='/men/tops' className='list-item__link'>
							Tops
						</a>
						<a href='/men/bottoms' className='list-item__link'>
							Bottoms
						</a>
						<a
							href='/men/undies-and-socks'
							className='list-item__link'>
							Undies + Socks
						</a>
						<a
							href='/men/bathing-suits'
							className='list-item__link'>
							Bathing Suits
						</a>
						<a href='/men/mens-yoga' className='list-item__link'>
							Men's Yoga
						</a>
						<a href='/men/' className='list-item__link'>
							All Men
						</a>
					</div>

					<div id='accessories' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<div
							className='list-item__link'
							data-navtoggle='jewelry'
							onClick={this.toggleNavs}>
							Jewelry
							<FAI icon='chevron-right' size='lg' />
						</div>
						<a href='/accessories/bags' className='list-item__link'>
							Bags
						</a>
						<div
							className='list-item__link'
							data-navtoggle='glasses'
							onClick={this.toggleNavs}>
							Sunnies + Readers
							<FAI icon='chevron-right' size='lg' />
						</div>
						<div
							className='list-item__link'
							data-navtoggle='bandanas-and-scarf'
							onClick={this.toggleNavs}>
							Bandanas + Scarf
							<FAI icon='chevron-right' size='lg' />
						</div>
						<a href='/accessories/hats' className='list-item__link'>
							Hats
						</a>
						<a
							href='/accessories/belts'
							className='list-item__link'>
							Belts
						</a>
						<a href='/accessories' className='list-item__link'>
							All Accessories
						</a>
					</div>

					<div id='beauty' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a href='/beauty/face' className='list-item__link'>
							Face
						</a>
						<div
							className='list-item__link'
							data-navtoggle='body'
							onClick={this.toggleNavs}>
							Body
							<FAI icon='chevron-right' size='lg' />
						</div>
						<a href='/beauty/hair' className='list-item__link'>
							Hair
						</a>
						<a href='/beauty/' className='list-item__link'>
							All Beauty
						</a>
					</div>

					<div id='shoes' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/shoes/womens-shoes'
							className='list-item__link'>
							Women's Shoes
						</a>
						<a href='/shoes/mens-shoes' className='list-item__link'>
							Men's Shoes
						</a>
						<a href='/shoes' className='list-item__link'>
							All Shoes
						</a>
					</div>

					<div id='home-goods' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/home-goods/bedding'
							className='list-item__link'>
							Bedding
						</a>
						<a
							href='/home-goods/candles'
							className='list-item__link'>
							Candles
						</a>
						<a
							href='/home-goods/art-and-decor'
							className='list-item__link'>
							Art + Decor
						</a>
						<a
							href='/home-goods/kitchen-and-bar'
							className='list-item__link'>
							Kitchen + Bar
						</a>
						<a
							href='/home-goods/purposeful-cleaning'
							className='list-item__link'>
							Purposeful Cleaning
						</a>
						<a
							href='/home-goods/outdoors'
							className='list-item__link'>
							Outdoors
						</a>
						<a href='/home-goods' className='list-item__link'>
							All Home Goods
						</a>
					</div>

					<div id='lifestyle' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/lifestyle/books-and-stationary'
							className='list-item__link'>
							Books + Stationary
						</a>
						<a href='/lifestyle/gift' className='list-item__link'>
							Gift
						</a>
					</div>

					<div id='about-us' className='list-items'>
						<div
							className='list-item__link'
							data-navtoggle='categories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/about-us/our-story'
							className='list-item__link'>
							Our Story
						</a>
						<a
							href='/about-us/ethical-production-standards'
							className='list-item__link'>
							Ethical Productions Standards
						</a>
						<a
							href='/about-us/ethical-glossary'
							className='list-item__link'>
							Ethical Glossary
						</a>
						<a
							href='/about-us/our-process'
							className='list-item__link'>
							Our Process
						</a>
						<a
							href='/about-us/as-seen-in'
							className='list-item__link'>
							As Seen In
						</a>
						<a href='/about-us/faqs' className='list-item__link'>
							FAQs
						</a>
						<a
							href='/about-us/our-team'
							className='list-item__link'>
							Our Team
						</a>
						<a
							href='http://blog.theetho.com'
							className='list-item__link'>
							Blog
						</a>
					</div>

					{/* THIRD TIER CATEGORIES */}

					<div className='list-items' id='jewelry'>
						<div
							className='list-item__link'
							data-navtoggle='accessories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/accessories/jewelry/watches'
							className='list-item__link'>
							Watches
						</a>
						<a
							href='/accessories/jewelry/earrings'
							className='list-item__link'>
							Ear Rings
						</a>
						<a
							href='/accessories/jewelry/necklaces'
							className='list-item__link'>
							Necklaces
						</a>
						<a
							href='/accessories/jewelry/bracelets'
							className='list-item__link'>
							Bracelets
						</a>
						<a
							href='/accessories/jewelry/rings'
							className='list-item__link'>
							Rings
						</a>
						<a
							href='/accessories/jewelry'
							className='list-item__link'>
							All Jewelry
						</a>
					</div>

					<div className='list-items' id='glasses'>
						<div
							className='list-item__link'
							data-navtoggle='accessories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/accessories/glasses/sunglasses'
							className='list-item__link'>
							Sunnies
						</a>
						<a
							href='/accessories/glasses/readers'
							className='list-item__link'>
							Readers
						</a>
						<a
							href='/accessories/glasses'
							className='list-item__link'>
							All Glasses
						</a>
					</div>

					<div className='list-items' id='bandanas-and-scarf'>
						<div
							className='list-item__link'
							data-navtoggle='accessories'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/accessories/bandanas-and-scarf/bandanas'
							className='list-item__link'>
							Bandanas
						</a>
						<a
							href='/accessories/bandanas-and-scarf/scarf'
							className='list-item__link'>
							Scarf
						</a>
						<a
							href='/accessories/banadanas-and-scarf'
							className='list-item__link'>
							All Bandanas + Scarf
						</a>
					</div>

					<div className='list-items' id='body'>
						<div
							className='list-item__link'
							data-navtoggle='beauty'
							onClick={this.toggleNavs}>
							<FAI icon='chevron-left' size='lg' />
							Back
						</div>
						<a
							href='/beauty/body/oils-balms-and-lotions'
							className='list-item__link'>
							Oils, Balms, + Lotions
						</a>
						<a href='/beauty/body' className='list-item__link'>
							All Body
						</a>
					</div>
				</div>
			</nav>
		)
	}
}

export default MobileMegaMenu
